/**
 * @file Renders a link to review an investment's document on DocuSign.
 */
import { Typography } from "antd";

const LABEL_REVIEW = "Review on DocuSign";

type Props = {
  href: string;
};

/**
 * Renders a link that opens the DocuSign document in a new tab.
 */
const DocusignLink = ({ href }: Props) => {
  return (
    <Typography.Link
      href={href}
      target="_blank"
    >
      {LABEL_REVIEW}
    </Typography.Link>
  );
};

export default DocusignLink;
